import { guardGameSurface } from './186-game-surface.mjs';

/** Own one deliberate pointer from press through release. Native cancellation,
 * focus loss and viewport movement retire aim without deploying or launching;
 * another finger can never release or steer the captured pointer. */
export function attachSteamInput(r, { listen, canPlay, paint, launch, wake }) {
  const { canvas, game, ui } = r;
  let pointer = null;
  const enabled = () =>
    canPlay() &&
    game.status !== 'paused' &&
    game.status !== 'gameover' &&
    !ui.rulesModal.classList.contains('is-visible') &&
    game.scoreboardMode !== 'view';
  const cancel = () => {
    const id = pointer;
    pointer = null;
    game.aiming = false;
    game.neutronPointerArmed = false;
    if (id !== null && canvas.hasPointerCapture?.(id)) canvas.releasePointerCapture?.(id);
  };
  listen(canvas, 'pointerdown', (event) => {
    if (event.button > 0 || event.isPrimary === false || pointer !== null || !enabled()) return;
    event.preventDefault();
    pointer = event.pointerId;
    canvas.focus({ preventScroll: true });
    canvas.setPointerCapture?.(pointer);
    const p = r.canvasPointFromEvent(event);
    game.neutronPointerArmed = r.isPointInNeutronFuelPanel(p.x, p.y);
    game.aiming = !game.neutronPointerArmed;
    if (game.aiming) r.setAngleFromPoint(event.clientX, event.clientY);
    paint();
  });
  listen(canvas, 'pointermove', (event) => {
    if (event.pointerId !== pointer) return;
    if (!enabled()) return cancel();
    if (!game.aiming) return;
    event.preventDefault();
    r.recordSpeedIdleInteraction();
    r.setAngleFromPoint(event.clientX, event.clientY);
    paint();
  });
  listen(canvas, 'pointerup', (event) => {
    if (event.pointerId !== pointer) return;
    const aim = game.aiming,
      armed = game.neutronPointerArmed;
    // Clear ownership before releasing capture; lostpointercapture may fire now.
    cancel();
    if (!enabled()) return;
    if (armed) {
      const p = r.canvasPointFromEvent(event);
      if (r.isPointInNeutronFuelPanel(p.x, p.y)) r.spawnNeutronBombDeployment();
      wake();
    } else if (aim) {
      r.setAngleFromPoint(event.clientX, event.clientY);
      launch(event);
    }
  });
  for (const type of ['pointercancel', 'lostpointercapture'])
    listen(canvas, type, (event) => {
      if (event.pointerId === pointer) {
        cancel();
        paint();
      }
    });
  const unguard = guardGameSurface(canvas, {
    cancel: () => {
      cancel();
      paint();
    },
  });
  return {
    cancel,
    dispose() {
      cancel();
      unguard();
    },
  };
}
